// Phase 25 iter-6 — patch role-assignment metadata (transporter, vet…).
//
// Backend: PATCH /api/v1/users/me/roles/:role  →  RolesResponse
// Body: UpdateRoleAssignmentRequestSchema (vet_license, transporter_*,
// vehicle_*, competence_cert_*).

import { API_VERSION_PREFIX, type RolesResponse, type UserRole } from '@leyrochain/shared';

import { apiClient } from './client';

export interface UpdateRoleAssignmentInput {
  vet_license?: string;
  transporter_auth_no?: string;
  transporter_auth_type?: string;
  transporter_auth_expiry?: string;
  vehicle_plate?: string;
  vehicle_auth_no?: string;
  competence_cert_no?: string;
  competence_cert_expiry?: string;
}

export async function updateRoleMetadata(
  role: UserRole,
  input: UpdateRoleAssignmentInput,
): Promise<RolesResponse> {
  const { data } = await apiClient.patch<RolesResponse>(
    `${API_VERSION_PREFIX}/users/me/roles/${role}`,
    input,
  );
  return data;
}
